import { useState, useEffect } from "react";
import { FaInstagram } from "react-icons/fa6";
import { TiSocialFacebook } from "react-icons/ti";
import { AiOutlineTwitter } from "react-icons/ai";
import { HiMenu, HiX } from "react-icons/hi"; // For hamburger and close icons
import { CiMenuFries } from "react-icons/ci";
import company_logo from "../assets/logos/black.webp";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { LiaLinkedinIn } from "react-icons/lia";
const Navbar = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isOpen, setIsOpen] = useState(false);
  const [isTop, setIsTop] = useState(true);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsTop(window.scrollY === 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav
        className={`bg-transparent w-full fixed top-0 z-20 transition-all duration-300 ${
          isTop ? "" : "transform -translate-y-full"
        }`}
      >
        <div className="w-full mx-auto px-[20px] md:px-[80px] flex justify-between items-center">
          {/* Logo */}
          <a href="/">
            <img
              src={company_logo}
              alt="Company Logo"
              onClick={closeMenu}
              className="w-full max-h-[120px] object-contain"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex gap-[20px] items-center font-[description1] text-[14px] font-bold">
          {/* <Link to="/about">
        <p className={`${currentPath === "/about" ? "border-b-2 border-black pb-1" : ""}`}>
          About
        </p>
      </Link> */}
      <Link to="/photography">
        <p className={`${currentPath === "/photography" ? "border-b-2 border-black pb-1" : ""}`}>
          Photography
        </p>
      </Link>
      <Link to="/films">
        <p className={`${currentPath === "/films" ? "border-b-2 border-black pb-1" : ""}`}>
          Films
        </p>
      </Link>
      <Link to="/connect">
        <p className={`${currentPath === "/connect" ? "border-b-2 border-black pb-1" : ""}`}>
          Connect
        </p>
      </Link>
            <a
              href="https://www.instagram.com/storiesby.rg/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              {" "}
              <FaInstagram size={18} />
            </a>
            <a
              href="https://www.facebook.com/storiesbyrg/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              {" "}
              <TiSocialFacebook size={20} />
            </a>
            <a
              href="https://www.linkedin.com/company/stories-by-rg/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              {" "}
              <LiaLinkedinIn size={20} />
            </a>
            <Link to="/connect">
              {" "}
              <button className="text-[13px] text-white font-bold rounded-md bg-black p-[15px]">
                Get In Touch
              </button>
            </Link>
          </div>

          {/* Hamburger for mobile */}
          <div className="md:hidden ">
            <button onClick={toggleMenu}>
              {isOpen ? (
                <HiX size={28} className="text-white" />
              ) : (
                <CiMenuFries size={28} className="text-black" />
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Full Screen Mobile Menu */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-95 text-white flex flex-col items-center font-[description1] justify-center gap-6 text-xl font-medium z-10 transition-all duration-500 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ transitionProperty: "transform" }}
      >
        {/* <Link to="/about">
          {" "}
          <p onClick={closeMenu} className="cursor-pointer">
            About
          </p>
        </Link> */}
        <Link to="/photography">
          {" "}
          <p onClick={closeMenu} className="cursor-pointer">
            Photography
          </p>
        </Link>
        <Link to="/films">
          {" "}
          <p onClick={closeMenu} className="cursor-pointer">
            Films
          </p>
        </Link>
        <Link to="/connect">
          {" "}
          <p onClick={closeMenu} className="cursor-pointer">
            Connect
          </p>
        </Link>
        <div className="flex gap-4 mt-[30px] mb-[30px]">
          <a
            href="https://www.instagram.com/storiesby.rg/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <FaInstagram size={22} />
          </a>
          <a
            href="https://www.facebook.com/storiesbyrg/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Read more"
          >
            {" "}
            <TiSocialFacebook size={24} />
          </a>
          <a
              href="https://www.linkedin.com/company/stories-by-rg/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Read more"
            >
              {" "}
              <LiaLinkedinIn size={24} />
            </a>
        </div>
        <Link to="/connect">
          {" "}
          <button
            className="mt-6 text-[15px] text-black rounded-md bg-white  px-6 py-3 font-[description1] font-bold"
            onClick={closeMenu}
          >
            Get In Touch
          </button>
        </Link>
      </div>
    </>
  );
};

export default Navbar;
